import React, { useEffect, useState } from 'react'
import styles from '../../css/style.module.css'
import { AddTrainingvideos, DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import HOC from '../../components/HOC/HOC'


import img from '../../assest/loading1.gif'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";

const columns = ['S.no', 'Title', 'Video','Description', 'Created At', 'Action'];


const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleDateString('en-US', options).replace(',', '');
}



const TrainingVideo = () => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const fetchData = async () => {
        await getApi(endPoints.getallvideos, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch Category!'
        });
    };

    useEffect(() => {
        fetchData();
    }, []);



    const handleDelete = async () => {
        if (!selectedData) return;

        await deleteApi(endPoints.deletevideo(selectedData), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete video!'
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);
    };


    const openDeleteModal = (categoryId) => {
        setSelectedData(categoryId);
        setShowDeleteModal(true);
    };

    const openEditModal = (category) => {
        setSelectedData(category);
        setEditMode(true);
        setShowAddModal(true);
    };



    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="Delete Training Video"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <AddTrainingvideos
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                videos={fetchData}
                data={selectedData}
                edit={editMode}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Training Videos</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={() => {
                            setEditMode(false);
                            setShowAddModal(true);
                        }}>
                            <FaPlus color='#FFFFFF' />
                            <p>Add New Video</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className={styles.loadingCell}>
                                            <img src={img} alt="Loading..." width={100} height={100} />
                                        </td>
                                    </tr>
                                ) : data?.data?.length ? (
                                    data?.data?.map((item, index) => (
                                        <tr key={item?._id} className={styles.tableRow}>
                                            <td>{index + 1}</td>
                                            <td>{item?.title}</td>
                                            <td><video src={item?.video} alt={item?.video} className={styles.videotable}/></td>
                                            <td>{item?.description}</td>
                                            <td>{formatDateTime(item?.createdAt)}</td>
                                            <td>
                                                <div className={styles.tableaction}>
                                                    <FaRegEdit size={20} onClick={() => openEditModal(item)}   style={{ cursor: "pointer", color: "#e9b44a" }} />
                                                    <RiDeleteBin6Line size={20} onClick={() => openDeleteModal(item._id)}    style={{ cursor: "pointer", color: "#d9534f" }}/>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className={styles.noDataCell}>No data available.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HOC(TrainingVideo)
